// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NYtFo","badges":"styles_badges__P-zAr"};